export const messages = {
  en: {
    allocationStorehouseApply: {
      title: 'Allocation Application',
      back: 'Back',
      warehouse: 'Warehouse',
      warehousePlaceholder: 'Required, please select warehouse',
      remark: 'Application Description',
      remarkPlaceholder: 'Required, please fill in application description',
      itemsTitle: 'Allocation Items',
      selectItems: 'Select Items',
      itemType: 'Item Type',
      itemName: 'Item Name',
      itemSpec: 'Item Specification',
      fixedItem: 'Fixed Item',
      sourceWarehouse: 'Source Warehouse',
      referencePrice: 'Reference Price',
      selectPrice: 'Please select price',
      stock: 'Stock',
      targetWarehouse: 'Target Warehouse',
      selectTargetWarehouse: 'Required, please select target warehouse',
      transferQuantity: 'Allocation Quantity',
      operation: 'Operation',
      cancelTransfer: 'Cancel Allocation',
      approverTitle: 'Approver',
      approver: 'Approver',
      selectApprover: 'Required, please select approver',
      select: 'Select',
      submit: 'Submit',
      selectWarehouseFirst: 'Please select warehouse first',
      fillRemarkFirst: 'Please fill in application description first',
      remarkRequired: 'Application description is required',
      selectItemsFirst: 'Please select items first',
      sameWarehouseRequired: 'Allocation items must come from the same warehouse',
      selectPriceFirst: 'Please select price first',
      stockNotEnough: 'Insufficient stock',
      selectTargetWarehouseFirst: 'Please select target warehouse first',
      fillQuantityFirst: 'Please fill in allocation quantity first',
      submitSuccess: 'Allocation application submitted successfully'
    },
    chooseResourceStore: {
      title: 'Select Items for Allocation',
      selectWarehouse: 'Please select warehouse',
      selectItemType: 'Please select item type',
      selectSubType: 'Please select sub type',
      inputItemName: 'Enter item management name',
      warehouseName: 'Warehouse Name',
      itemType: 'Item Type',
      itemName: 'Item Name',
      itemSpec: 'Item Specification',
      itemCode: 'Item Code',
      isFixedItem: 'Is Fixed Item',
      itemStock: 'Item Stock',
      selectItemFirst: 'Please select items first'
    },
  },
  zh: {
    allocationStorehouseApply: {
      title: '调拨申请',
      back: '返回',
      warehouse: '仓库',
      warehousePlaceholder: '必填，请选择仓库',
      remark: '申请说明',
      remarkPlaceholder: '必填，请填写申请说明',
      itemsTitle: '调拨物品',
      selectItems: '选择物品',
      itemType: '物品类型',
      itemName: '物品名称',
      itemSpec: '物品规格',
      fixedItem: '固定物品',
      sourceWarehouse: '源仓库',
      referencePrice: '参考价格',
      selectPrice: '请选择价格',
      stock: '库存',
      targetWarehouse: '目标仓库',
      selectTargetWarehouse: '必填，请选择目标仓库',
      transferQuantity: '调拨数量',
      operation: '操作',
      cancelTransfer: '取消调拨',
      approverTitle: '审批人',
      approver: '审批人',
      selectApprover: '必填，请选择审批人',
      select: '选择',
      submit: '提交',
      selectWarehouseFirst: '请先选择仓库',
      fillRemarkFirst: '请先填写申请说明',
      remarkRequired: '申请说明不能为空',
      selectItemsFirst: '请先选择物品',
      sameWarehouseRequired: '调拨商品需来自同一仓库',
      selectPriceFirst: '请先选择价格',
      stockNotEnough: '库存不足',
      selectTargetWarehouseFirst: '请先选择目标仓库',
      fillQuantityFirst: '请先填写调拨数量',
      submitSuccess: '调拨申请提交成功'
    },
    chooseResourceStore: {
      title: '【调拨申请】选择物品',
      selectWarehouse: '请选择仓库',
      selectItemType: '请选择物品类型',
      selectSubType: '请选择二级分类',
      inputItemName: '输入物品管理名称',
      warehouseName: '仓库名称',
      itemType: '物品类型',
      itemName: '物品名称',
      itemSpec: '物品规格',
      itemCode: '物品编码',
      isFixedItem: '是否是固定物品',
      itemStock: '物品库存',
selectItemFirst: '请先选择物品'
    },
  },
  'zh-TW': {
    allocationStorehouseApply: {
      title: '調撥申請',
      back: '返回',
      warehouse: '倉庫',
      warehousePlaceholder: '必填，請選擇倉庫',
      remark: '申請說明',
      remarkPlaceholder: '必填，請填寫申請說明',
      itemsTitle: '調撥物品',
      selectItems: '選擇物品',
      itemType: '物品類型',
      itemName: '物品名稱',
      itemSpec: '物品規格',
      fixedItem: '固定物品',
      sourceWarehouse: '源倉庫',
      referencePrice: '參考價格',
      selectPrice: '請選擇價格',
      stock: '庫存',
      targetWarehouse: '目標倉庫',
      selectTargetWarehouse: '必填，請選擇目標倉庫',
      transferQuantity: '調撥數量',
      operation: '操作',
      cancelTransfer: '取消調撥',
      approverTitle: '審批人',
      approver: '審批人',
      selectApprover: '必填，請選擇審批人',
      select: '選擇',
      submit: '提交',
      selectWarehouseFirst: '請先選擇倉庫',
      fillRemarkFirst: '請先填寫申請說明',
      remarkRequired: '申請說明不能為空',
      selectItemsFirst: '請先選擇物品',
      sameWarehouseRequired: '調撥商品需來自同一倉庫',
      selectPriceFirst: '請先選擇價格',
      stockNotEnough: '庫存不足',
      selectTargetWarehouseFirst: '請先選擇目標倉庫',
      fillQuantityFirst: '請先填寫調撥數量',
      submitSuccess: '調撥申請提交成功'
    },
    chooseResourceStore: {
      title: '【調撥申請】選擇物品',
      selectWarehouse: '請選擇倉庫',
      selectItemType: '請選擇物品類型',
      selectSubType: '請選擇二級分類',
      inputItemName: '輸入物品管理名稱',
      warehouseName: '倉庫名稱',
      itemType: '物品類型',
      itemName: '物品名稱',
      itemSpec: '物品規格',
      itemCode: '物品編碼',
      isFixedItem: '是否是固定物品',
      itemStock: '物品庫存',
      selectItemFirst: '請先選擇物品'
    },
  }
}